import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { FormType } from 'src/app/common/enumerations/enumerations';
import * as ChecklistsActions from 'src/app/components/checklists/store/checklists/checklists.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class ChecklistsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore(documentType: FormType | null = null) {
    if (documentType) {
      this.store.dispatch(new ChecklistsActions.ChecklistsRefreshByDocumentMin(documentType));
    }
    else {
      this.store.dispatch(new ChecklistsActions.ChecklistsRefresh());
    }
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.CHECKLISTS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new ChecklistsActions.ChecklistsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new ChecklistsActions.ChecklistsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new ChecklistsActions.ChecklistsDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new ChecklistsActions.ChecklistsRefresh());
          break;

        case SignalRAction.PartialUpdate:
          this.store.dispatch(new ChecklistsActions.ChecklistsUpdateSection(data.id, data.obj));
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new ChecklistsActions.ChecklistsRefreshById(data.id));
          break;
      }
    });
  }
}
